import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { isCartVisibleSelector } from "@client/widgets/Header/selectors";
import Component from "./component";

const mapStateToProps = (state: AppState): WithIsVisibleHOCProps => {
  return {
    isVisible: isCartVisibleSelector(state)
  };
};

export default connectCustom(mapStateToProps)(Component);
